<template>
  <div id="ChangePasswordForm">
    <div class="modal-card fixed-width">
      <!-- Modal Title -->
      <header class="modal-card-head">
        <p class="modal-card-title">CHANGE PASSWORD</p>
      </header>
      <!-- Modal Description + Input -->
      <section class="modal-card-body">
        <div class="media">
          <div class="media-content">
            <!-- Modal Description -->
            <p class="subtitle is-6">
              Please input your old password and fill in the new one below.
            </p>
            <!-- Modal Input Field -->
            <b-field>
              <b-input
                required
                type="password"
                password-reveal
                v-model="old_password"
                placeholder="Old Password"
              />
            </b-field>
            <!-- Modal Input Field -->
            <b-field>
              <b-input
                required
                type="password"
                password-reveal
                v-model="new_password"
                placeholder="New Password"
              />
            </b-field>
          </div>
        </div>
      </section>
      <!-- Modal Footer -->
      <footer class="modal-card-foot" style="justify-content: flex-end;">
        <!-- Button: Save -->
        <button
          class="button is-primary"
          :disabled="disableChangePassword"
          @click.prevent="performChangePassword()"
        >
          Confirm
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import UserApi from "@/services/UserApi";
import AlertManager from "@/utils/AlertManager";

export default {
  name: "ChangePasswordForm",
  props: ["user_id"],
  data() {
    return {
      old_password: null,
      new_password: null
    };
  },
  computed: {
    disableChangePassword: function() {
      if (
        this.old_password &&
        this.old_password !== "" &&
        this.new_password &&
        this.new_password !== ""
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    performChangePassword: async function() {
      if (!this.disableChangePassword) {
        const params = {
          old_password: this.old_password,
          new_password: this.new_password
        };
        const loadingComponent = this.$buefy.loading.open({
          container: null
        });
        const response = await UserApi.requestChangePassword(params);
        loadingComponent.close();

        if (response.status) {
          this.$emit("close");
          AlertManager.showSuccessSnackbar(response.message);
        } else {
          AlertManager.showErrorSnackbar(response.message);
        }
      }
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 420px;
  padding: 0 20px;
}
</style>
